<script>
  export default {
    props: {
      parKey: Number,
      paragraph: Object,
      selectedClassName: {
        type: String,
        default: ''
      },
      noOfSelectedSentences: {
        type: Number,
        required: true
      }
    },
    computed: {
      paragraphType () {
        const lastDashPosition = this.paragraph.type.lastIndexOf('-') + 1;
        return this.paragraph.type.substring(lastDashPosition)
      }
    },
    render: function (createElement) {
      const paragraph = this.paragraph.content ? this.paragraph.content.replace(/\. /g, '. {{new_sentence}}') : '';
      const sentences = paragraph.split('{{new_sentence}}');
      let sentencesElementArray = [];
      sentences.map((sentence, i) => {
        sentencesElementArray.push(createElement('span', {
          class: { [this.selectedClassName]: this.noOfSelectedSentences === -1 || this.noOfSelectedSentences >= i+1 },
          domProps: { innerHTML: sentence }
          },
        sentence))
      });

      let elementAttributes = {id: 'editor-content-' + this.parKey};
      let style = {};
      if (this.paragraph.type.indexOf('embed') !== -1) {
        style = { display: 'block', margin: '10px auto 30px auto', maxWidth: '1024px' };
        elementAttributes = { ...elementAttributes, ...this.paragraph};

        if (this.paragraphType === 'video') {
          elementAttributes = { ...elementAttributes, controls: true }
          delete elementAttributes.src;
          style = { 
            display: 'block',
            margin: '10px auto 30px auto',
            maxWidth: '640px',
            width: '100%',
            height: 'auto'
          };
        } else {
          style = { 
            display: 'block',
            margin: '10px auto 30px auto',
            maxWidth: '100%'
          };
        }
      }

      let element = createElement(
        this.paragraphType, {
          class: 'editor-content',
          attrs: elementAttributes,
          style
        },
        this.paragraph.type.indexOf('embed') === -1 ? sentencesElementArray : ''
      );

      if (this.paragraphType === 'video') {
        const sourceAttributes = { src: this.paragraph.src, type: this.paragraph.filetype };
        const sourceElement = createElement('source', { attrs: sourceAttributes });

        element.children.push(sourceElement);
      }

      return element;
    }
  }
</script>